// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  width: 100%;
  padding: 80px 0;
  box-sizing: border-box;
  background-color: #2b2a29;
}
.footer-content {
  display: flex;
  justify-content: space-between;
}
.footer-content-left {
  display: flex;
  flex-direction: column;
}
.footer-content-left-info {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
}
.footer-content-left-info span {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 400;
  color: #fefefe;
}
.footer-content-left-info span:first-child {
  margin-top: 0;
  font-size: 14px;
  color: #898989;
}
.footer-content-left-links {
  display: flex;
  align-items: center;
  margin-top: 32px;
}
.footer-content-left-links button {
  margin-right: 12px;
  border: 0;
  outline: none;
  background-color: transparent;
  cursor: pointer;
}
.footer-content-left-links button a {
  text-decoration: none;
}
.footer-content-right {
  display: flex;
}
.footer-content-right-block {
  display: flex;
  flex-direction: column;
  margin-left: 40px;
}
.footer-content-right-block span {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #fefefe;
  cursor: pointer;
}
.footer-content-right-block span a {
  font-size: 14px;
  font-weight: 400;
  color: #fefefe;
  text-decoration: none;
}
.footer-content-right-block span a:hover {
  color: #6E00FF;
}
.footer-content-right-block span:hover {
  color: #6E00FF;
}
.footer-bottom {
  margin-top: 80px;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  border-top: 1px solid rgba(67, 66, 66, 0.4);
}
.footer-bottom span {
  margin-top: 32px;
  font-size: 14px;
  font-weight: 400;
  color: #898989;
}
.footer-bottom span:last-child {
  margin-left: 24px;
}

@media (max-width: 1024px) {
  .footer {
    padding: 20px 0;
  }
}
@media (max-width: 768px) {
  .footer-content {
    width: 100%;
    flex-direction: column;
  }
  .footer-content-right {
    margin-top: 20px;
  }
  .footer-content-right-block {
    margin-left: 0;
  }
  .footer-bottom {
    margin-top: 40px;
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-bottom-political {
    display: flex;
    flex-direction: column;
  }
  .footer-bottom-political span:last-child {
    margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;AACF;AAAE;EACE,aAAA;EACA,8BAAA;AAEJ;AADI;EACE,aAAA;EACA,sBAAA;AAGN;AAFM;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AAIR;AAHQ;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAKV;AAJU;EACE,aAAA;EACA,eAAA;EACA,cAAA;AAMZ;AAFM;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAIR;AAHQ;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;AAKV;AAJU;EACE,qBAAA;AAMZ;AADI;EACE,aAAA;AAGN;AAFM;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAIR;AAHQ;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAKV;AAJU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAMZ;AALY;EACE,cAAA;AAOd;AAJU;EACE,cAAA;AAMZ;AAAE;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,2CAAA;AAEJ;AADI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAGN;AAFM;EACE,iBAAA;AAIR;;AAEA;EACE;IACE,eAAA;EACF;AACF;AAEA;EAEI;IACE,WAAA;IACA,sBAAA;EADJ;EAEI;IACE,gBAAA;EAAN;EACM;IACE,cAAA;EACR;EAGE;IACE,gBAAA;IACA,sBAAA;IACA,uBAAA;EADJ;EAEI;IACE,aAAA;IACA,sBAAA;EAAN;EACM;IACE,cAAA;EACR;AACF","sourcesContent":[".footer {\n  width: 100%;\n  padding: 80px 0;\n  box-sizing: border-box;\n  background-color: #2b2a29;\n  &-content {\n    display: flex;\n    justify-content: space-between;\n    &-left {\n      display: flex;\n      flex-direction: column;\n      &-info {\n        margin-top: 32px;\n        display: flex;\n        flex-direction: column;\n        & span {\n          margin-top: 5px;\n          font-size: 16px;\n          font-weight: 400;\n          color: #fefefe;\n          &:first-child {\n            margin-top: 0;\n            font-size: 14px;\n            color: #898989;\n          }\n        }\n      }\n      &-links {\n        display: flex;\n        align-items: center;\n        margin-top: 32px;\n        & button {\n          margin-right: 12px;\n          border: 0;\n          outline: none;\n          background-color: transparent;\n          cursor: pointer;\n          & a {\n            text-decoration: none;\n          }\n        }\n      }\n    }\n    &-right {\n      display: flex;\n      &-block {\n        display: flex;\n        flex-direction: column;\n        margin-left: 40px;\n        & span {\n          margin-bottom: 10px;\n          font-size: 14px;\n          font-weight: 400;\n          color: #fefefe;\n          cursor: pointer;\n          & a {\n            font-size: 14px;\n            font-weight: 400;\n            color: #fefefe;\n            text-decoration: none;\n            &:hover {\n              color: #6E00FF;\n            }\n          }\n          &:hover {\n            color: #6E00FF;\n          }\n        }\n      }\n    }\n  }\n  &-bottom {\n    margin-top: 80px;\n    width: 100%;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    border-top: 1px solid #43424266;\n    & span {\n      margin-top: 32px;\n      font-size: 14px;\n      font-weight: 400;\n      color: #898989;\n      &:last-child {\n        margin-left: 24px;\n      }\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .footer {\n    padding: 20px 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer {\n    &-content {\n      width: 100%;\n      flex-direction: column;\n      &-right {\n        margin-top: 20px;\n        &-block {\n          margin-left: 0;\n        }\n      }\n    }\n    &-bottom {\n      margin-top: 40px;\n      flex-direction: column;\n      align-items: flex-start;\n      &-political {\n        display: flex;\n        flex-direction: column;\n        & span:last-child {\n          margin-left: 0;\n        }\n      }\n    }\n  }\n}\n\n// @media (max-width: 480px) {\n//   .footer {\n\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
